import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import ResetPasswordRequest from "./views/ResetPasswordRequest.vue";
import ResetPassword from "./views/ResetPassword.vue";
import NotFound from './views/NotFound.vue';
import { authUser, User } from './auth/User';
import Unauthorized from './views/Unauthorized.vue'
Vue.use(Router)


const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            meta: { guest: true },
            component: Home
        },
        {
            path: "/users",
            name: "users",
            meta: { roles: ['admin'] },
            component: () => import("./views/Users.vue")
        },
        {
            path: "/users/:id",
            name: "user",
            meta: { roles: ['admin'] },
            component: () => import("./views/User.vue")
        },
        {
            path: "/emma",
            name: "emma",
            meta: { roles: ['admin', 'coc'] },
            component: () => import("./views/Emma.vue")
        },
        {
            path: "/emma/address-book",
            name: "address-book",
            meta: { roles: ['admin', 'coc'] },
            component: () => import("./Emma/AddressBook.vue")
        },
        {
            path: "/emgyne",
            name: "emgyne",
            meta: { roles: [ 'admin', 'engineer' ] },
            component: () => import("./views/Emgyne.vue")
        },
        {
            path: "/auth/login",
            name: "login",
            component: Login,
            meta: { guest: true },
            props: route => ({ return_url: route.query.return_url })
        },
        {
            path: "/auth/reset-password-request",
            name: "reset-password-request",
            component: ResetPasswordRequest,
            meta: { guest: true }
        },
        {
            path: "/auth/reset-password",
            name: "reset-password",
            component: ResetPassword,
            props: route => ({ token: route.query.token }),
            meta: { guest: true }
        },
        {
            path: "/auth/logout",
            name: "logout"
        },
        { path: '/401', meta: { guest: true }, component: Unauthorized },
        { path: "/404", meta: { guest: true },  component: NotFound },
        { path: "*", meta: { guest: true }, redirect: "/404" }
    ]
});


router.beforeEach( ( to, _from, next ) =>
{
    if( to.meta.guest )
        next();
    else if( to.path === '/auth/logout' )
    {
        authUser.logout();
        next( { path: '/' } );
    }
    else
    {
        let url = to.fullPath.replace(/(emgyne|emma).*$/, '$1')
        if( !authUser.isAuthenticated() )
            next({ path: '/auth/login', query: { 'return_url': url } });
        else if( !( 'roles' in to.meta ) || Object.keys( authUser.roles ).some( role => to.meta.roles.includes( role ) ))
            next();
        else
            next( { path: '/403' } );
    }
});


export default router;
